// extracted by mini-css-extract-plugin
export default {"modalHeader":"HelpModal_modalHeader__BOn9S","closeIcon":"HelpModal_closeIcon__jLVae","title":"HelpModal_title__QXehu","text":"HelpModal_text__3lSCJ"};